import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80f1bc4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "填充颜色：", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框样式：", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框颜色：", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框粗细：", -1))

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTElement, PPTElementOutline, TableCell } from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import TextColorButton from '../common/TextColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Divider from '@/components/Divider.vue'
import Button from '@/components/Button.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'
import RadioButton from '@/components/RadioButton.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import NumberInput from '@/components/NumberInput.vue'
import Select from '@/components/Select.vue'
import SelectGroup from '@/components/SelectGroup.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { richTextAttrs, availableFonts, activeElementList } = storeToRefs(useMainStore())

const { addHistorySnapshot } = useHistorySnapshot()

const updateElement = (id: string, props: Partial<PPTElement>) => {
  slidesStore.updateElement({ id, props })
  addHistorySnapshot()
}

const fontSizeOptions = [
  '12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px',
  '36px', '40px', '44px', '48px', '54px', '60px', '66px', '72px', '76px',
  '80px', '88px', '96px', '104px', '112px', '120px',
]

const fill = ref('#fff')
const outline = ref<PPTElementOutline>({
  width: 0,
  color: '#fff',
  style: 'solid',
})

// 批量修改填充色（表格元素为单元格填充、音频元素为图标颜色）
const updateFill = (value: string) => {
  for (const el of activeElementList.value) {
    if (
      el.type === 'text' ||
      el.type === 'shape' ||
      el.type === 'chart'
    ) updateElement(el.id, { fill: value })

    if (el.type === 'table') {
      const data: TableCell[][] = JSON.parse(JSON.stringify(el.data))
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          const style = data[i][j].style || {}
          data[i][j].style = { ...style, backcolor: value }
        }
      }
      updateElement(el.id, { data })
    }

    if (el.type === 'audio') updateElement(el.id, { color: value })
  }
  fill.value = value
}

// 修改边框/线条样式
const updateOutline = (outlineProps: Partial<PPTElementOutline>) => {

  for (const el of activeElementList.value) {
    if (
      el.type === 'text' ||
      el.type === 'image' ||
      el.type === 'shape' ||
      el.type === 'table' ||
      el.type === 'chart'
    ) {
      const outline = el.outline || { width: 2, color: '#000', style: 'solid' }
      const props = { outline: { ...outline, ...outlineProps } }
      updateElement(el.id, props)
    }

    if (el.type === 'line') updateElement(el.id, outlineProps)
  }
  outline.value = { ...outline.value, ...outlineProps }
}

// 修改文字样式
const updateFontStyle = (command: string, value: string) => {
  for (const el of activeElementList.value) {
    if (el.type === 'text' || (el.type === 'shape' && el.text?.content)) {
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { target: el.id, action: { command, value } })
    }
    if (el.type === 'table') {
      const data: TableCell[][] = JSON.parse(JSON.stringify(el.data))
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          const style = data[i][j].style || {}
          data[i][j].style = { ...style, [command]: value }
        }
      }
      updateElement(el.id, { data })
    }
    if (el.type === 'latex' && command === 'color') {
      updateElement(el.id, { color: value })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconAddText = _resolveComponent("IconAddText")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: fill.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = value => updateFill(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, { color: fill.value }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode(Divider),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(Select, {
        style: {"width":"60%"},
        value: outline.value.style || '',
        "onUpdate:value": _cache[1] || (_cache[1] = value => updateOutline({ style: value as 'solid' | 'dashed' })),
        options: [
          { label: '实线边框', value: 'solid' },
          { label: '虚线边框', value: 'dashed' },
        ]
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: outline.value.color,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = value => updateOutline({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: outline.value.color || '#000'
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(NumberInput, {
        value: outline.value.width || 0,
        "onUpdate:value": _cache[3] || (_cache[3] = value => updateOutline({ width: value })),
        style: {"width":"60%"}
      }, null, 8, ["value"])
    ]),
    _createVNode(Divider),
    _createVNode(SelectGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(Select, {
          style: {"width":"60%"},
          value: _unref(richTextAttrs).fontname,
          "onUpdate:value": _cache[4] || (_cache[4] = value => updateFontStyle('fontname', value as string)),
          options: [
          ..._unref(availableFonts),
          ..._unref(WEB_FONTS)
        ]
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconFontSize)
          ]),
          _: 1
        }, 8, ["value", "options"]),
        _createVNode(Select, {
          style: {"width":"40%"},
          value: _unref(richTextAttrs).fontsize,
          "onUpdate:value": _cache[5] || (_cache[5] = value => updateFontStyle('fontsize', value as string)),
          options: fontSizeOptions.map(item => ({
          label: item, value: item
        }))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconAddText)
          ]),
          _: 1
        }, 8, ["value", "options"])
      ]),
      _: 1
    }),
    _createVNode(ButtonGroup, {
      class: "row",
      passive: ""
    }, {
      default: _withCtx(() => [
        _createVNode(Popover, {
          trigger: "click",
          style: {"width":"30%"}
        }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: _unref(richTextAttrs).color,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = value => updateFontStyle('color', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(TextColorButton, {
              first: "",
              color: _unref(richTextAttrs).color
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconText)
              ]),
              _: 1
            }, 8, ["color"])), [
              [_directive_tooltip, '文字颜色']
            ])
          ]),
          _: 1
        }),
        _createVNode(Popover, {
          trigger: "click",
          style: {"width":"30%"}
        }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: _unref(richTextAttrs).backcolor,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = value => updateFontStyle('backcolor', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(TextColorButton, {
              color: _unref(richTextAttrs).backcolor
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconHighLight)
              ]),
              _: 1
            }, 8, ["color"])), [
              [_directive_tooltip, '文字高亮']
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(Button, {
          class: "font-size-btn",
          style: {"width":"20%"},
          onClick: _cache[8] || (_cache[8] = ($event: any) => (updateFontStyle('fontsize-add', '2')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconFontSize),
            _createTextVNode("+")
          ]),
          _: 1
        })), [
          [_directive_tooltip, '增大字号']
        ]),
        _withDirectives((_openBlock(), _createBlock(Button, {
          last: "",
          class: "font-size-btn",
          style: {"width":"20%"},
          onClick: _cache[9] || (_cache[9] = ($event: any) => (updateFontStyle('fontsize-reduce', '2')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconFontSize),
            _createTextVNode("-")
          ]),
          _: 1
        })), [
          [_directive_tooltip, '减小字号']
        ])
      ]),
      _: 1
    }),
    _createVNode(RadioGroup, {
      class: "row",
      "button-style": "solid",
      value: _unref(richTextAttrs).align,
      "onUpdate:value": _cache[10] || (_cache[10] = value => updateFontStyle('align', value))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(RadioButton, {
          value: "left",
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconAlignTextLeft)
          ]),
          _: 1
        })), [
          [_directive_tooltip, '左对齐']
        ]),
        _withDirectives((_openBlock(), _createBlock(RadioButton, {
          value: "center",
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconAlignTextCenter)
          ]),
          _: 1
        })), [
          [_directive_tooltip, '居中']
        ]),
        _withDirectives((_openBlock(), _createBlock(RadioButton, {
          value: "right",
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconAlignTextRight)
          ]),
          _: 1
        })), [
          [_directive_tooltip, '右对齐']
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})